import { SuiGrpcClient } from '@mysten/sui/grpc';
import { Transaction } from '@mysten/sui/transactions';
import { WalletAccount } from '@mysten/wallet-standard';

import { SuiNetworks } from '@/types';

import { getFarmsSdk } from './config';

export const getFarmingAddLiquidityTxb = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const txb: Transaction = await peripherySdk.Farms.openPositionAddLiquidityStakePayload(txbParams);
  return txb;
};

export const getFarmingIncreaseLiquidityTxb = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const txb: Transaction = await peripherySdk.Farms.addLiquidityFixCoinPayload(txbParams);
  return txb;
};

export const getFarmingDecreaseLiquidityTxb = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const txb: Transaction = await peripherySdk.Farms.removeLiquidityPayload(txbParams);
  return txb;
};

export const getFarmingVestDecreaseLiquidityTxb = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const txb: Transaction = await peripherySdk.Farms.removeAllLiquidityPayload(txbParams);
  return txb;
};

export const getFarmingRemoveLiquidityTxb = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const txb: Transaction = await peripherySdk.Farms.removeLiquidityPayload(txbParams);
  return txb;
};

export const getFarmingClaimFeeAndRewardTxb = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const txb: Transaction = await peripherySdk.Farms.claimFeeAndClmmReward(txbParams);
  return txb;
};

export const getFarmingHarvest = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const txb: Transaction = await peripherySdk.Farms.harvestPayload(txbParams);
  return txb;
};

export const getFarmingBatchHarvest = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const params: any = Object.values(txbParams);
  const txb: Transaction = await peripherySdk.Farms.batchHarvestPayload(params);
  return txb;
};

export const getFarmingStake = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const txb: Transaction = await peripherySdk.Farms.depositPayload(txbParams);
  return txb;
};

export const getFarmingUnstake = async (
  txbParams: any,
  account: WalletAccount,
  network: SuiNetworks,
  suiGrpcClient: SuiGrpcClient,
): Promise<Transaction> => {
  const peripherySdk = await getFarmsSdk(network, account, suiGrpcClient);
  const txb: Transaction = await peripherySdk.Farms.withdrawPayload(txbParams);
  return txb;
};
